import React from "react";
import { Modal, Button } from "react-bootstrap";

const ViewData = ({ show, onCancel, systemLogs, currentLogIndex, rows, showAllLogs, logId }) => {
    
    const allLogs = rows ? rows.find(log => log.id === logId) : null;
    const previousLog = systemLogs && currentLogIndex > 0 ? systemLogs[currentLogIndex - 1] : null;
    
    const isAllLogs = showAllLogs === true;
    const logData = isAllLogs ? allLogs : previousLog;
    const modalTitle = isAllLogs ? "All Logs" : "Previous Log";
    const noRecordMessage = isAllLogs ? "No logs available." : "No previous log available.";

    return (
        <Modal show={show} onHide={onCancel} size="lg" scrollable>
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {logData ? (
                    <pre>{JSON.stringify(logData, null, 2)}</pre>
                ) : (
                    <p className="text-center">{noRecordMessage}</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" size="sm" onClick={onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewData;
